export default __webpack_public_path__ + "static/media/Venturer's Gauntlets of the Savage Sun.33ed0b99.jpg";